<template>
  <!--
    メニュー画面のレイアウト

    位置固定のヘッダ、フッタがあり、中央にメニュー一覧配置用のコンテナがあるパターンです。
  -->
  <div class="container">
    <header>
      <div class="content-left"></div>
      <div class="content-right">
        <gl-button icon-button @click="moveToHelp">
          <gl-icon-help />
        </gl-button>
        <gl-button
          v-if="isSettingAvailable"
          icon-button
          @click="$router.push('preferences')"
        >
          <gl-icon-setting style="color:rgba(0,0,0,0.54)" />
        </gl-button>
        <gl-button icon-button @click="logout">
          <md-icon>
            <font-awesome-icon icon="sign-out-alt" />
          </md-icon>
        </gl-button>
      </div>
    </header>

    <main>
      <slot></slot>
    </main>

    <footer>
      <app-footer></app-footer>
    </footer>
  </div>
</template>

<script>
import firebase from 'firebase/app'

import AppFooter from '@/components/common/AppFooter.vue'
import { SET_ACCOUNT } from '@/const/mutation-types'

export default {
  components: { AppFooter },
  data() {
    return {
      isSettingAvailable: false,
    }
  },
  computed: {
    loginId() {
      return this.$store.state.account.loginId
    },
  },
  methods: {
    moveToHelp() {
      window.open(process.env.VUE_APP_HELP_SITE_URL_BASE)
    },
    /**
     * ログアウト
     */
    async logout() {
      this.$store.commit(SET_ACCOUNT, {})
      await firebase.auth().signOut()
      location.reload()
    },
  },
  mounted() {
    // 遊びなので消しても大丈夫です。
    const subscription = fromEvent(document, 'keydown').subscribe(e => {
      if (keyInputs.length >= COMMAND.length) {
        keyInputs.shift()
      }
      keyInputs.push(e.key)
      if (isEqual(keyInputs, COMMAND)) {
        this.isSettingAvailable = true
      }
    })
    this.$on('hook:beforeDestroy', () => subscription.unsubscribe())
  },
}

// 遊びなので消しても大丈夫です。
import { fromEvent } from 'rxjs'
import { isEqual } from 'lodash'
const COMMAND = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
]
const keyInputs = []
</script>

<style lang="scss" scoped>
.container {
  height: calc(100% - 78px);
  display: flex;
  align-items: center;
}

// TODO 今はヘッダとフッタがコンテンツに被らない高さで表示される
//      前提ですが、そうなった場合どうするか要検討です。

header {
  display: flex;
  align-items: center;
  display: flex;
  padding: var(--spacing-large);
  position: fixed;
  top: 0;
  width: 100%;

  .content-left {
    flex: 1;
  }
  .content-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .name {
    display: inline-block;
    font-size: var(--font-size-large);
    margin-left: var(--spacing-medium);
  }
}

main {
  display: flex;
  width: 100%;
}

footer {
  bottom: 0;
  position: fixed;
  width: 100%;
}
</style>
